import * as Sentry from '@sentry/browser'

export function setUserContext(_context) {
    // https://docs.sentry.io/enriching-error-data/_/?platform=browser#capturing-the-user
    // id, username, email
    Sentry.configureScope(scope => {
        scope.setUser(_context)
    })
}

function invariant(value, msg) {
    if (typeof value === 'undefined') {
        throw new Error(msg)
    }
}

export function install(
    { sentryDsn, debug, environment, release },
    win = window,
) {
    invariant(win, 'window is required')
    invariant(sentryDsn, 'sentryDsn is required')
    invariant(debug, 'debug is required')
    invariant(environment, 'environment is required')
    invariant(release, 'release is required')

    if (typeof win === 'undefined') {
        throw new Error('window required to install errorHandling')
    }

    if (win._fictivBase) {
        return
    }

    win._fictivBase = true

    // Calling config & install again has no effect
    try {
        // https://docs.sentry.io/error-reporting/configuration/?platform=browser
        Sentry.init({
            dsn: sentryDsn,
            debug,
            environment,
            release,
            ignoreErrors: [
                'ResizeObserver loop limit exceeded',
                'Non-Error promise rejection captured',
            ],
        })
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('error configuring Sentry', e)
    }

    // Is it possible to not attach Sentry to the window? If so,
    // we could skip this singleton deal.
    win.Sentry = Sentry
}
